

import request from '@/libs/request';



export function wechatListApi(data) {
  return request({
    url: '/setting/wechat',
    method: 'get',
    params: data,
  });
}

export function getWechatTodayCount(id) {
  return request({
    url: '/setting/wechat/count/today/'+id,
    method: 'get',
  });
}


export function wechatAdinAllApi(adminId,data) {
  return request({
    url: '/setting/wechat/admin/all/'+adminId,
    method: 'get',
    params: data,
  });
}


export function wechatAddApi(data) {
  return request({
    url: '/setting/wechat',
    method: 'post',
    data,
  });
}

export function wechatBatchAddApi(adminId,data) {
  return request({
    url: '/setting/wechat/batch/add/'+adminId,
    method: 'post',
    data,
  });
}


export function wechatUpdateAdminApi(id,admin_id) {
  return request({
    url: '/setting/wechat/update_admin/'+id+'/'+admin_id,
    method: 'put',
  });
}





export function setShowApi(data) {
  return request({
    url: `/setting/wechat/set_status/${data.id}/${data.status}`,
    method: 'put'
  });
}

export function wechatInfoApi (id) {
    return request({
        url: `/setting/wechat/${id}`,
        method: 'get'
    })
};


export function wechatDetailsApi (id) {
    return request({
        url: `/setting/wechat/details/${id}`,
        method: 'get'
    })
};

export function loginAdminWechats(data) {
  return request({
    url: 'auth/admin/wechats',
    method: 'get',
    data,
  });
}

export function swithUseApi(id) {
  return request({
    url: `/setting/wechat/swith_use/${id}`,
    method: 'put'
  });
}



export function wecomsApi() {
  return request({
    url: '/setting/wechat/wecoms/list',
    method: 'get',
  });
}


export function systemSwithUseApi(adminId,id) {
  return request({
    url: `/setting/wechat/system_swith_use/${adminId}/${id}`,
    method: 'put'
  });
}



export function qrcodeTeamAllApi(code) {
  return request({
    url: '/setting/wechat/team/all/'+code,
    method: 'get',
  });
}


export function getAdminWechatApi(adminId) {
  return request({
    url: '/setting/wechat/admin/'+adminId,
    method: 'get',
  });
}